/**
 * @file: 文本框 render 方法
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../../cubeTree/index';
import * as Toolkit from '../../../toolkit/index';
import * as UIToolkit from '../../../UIToolkit/index';
import FrontCubeData from '../../../frontCubeData/index';

export function textarea(cube: CubeNode): void {
    let parent: CubeId = CubeTree.findParentIdByCubeId(cube.id);
    let $el: JQuery<HTMLElement> = cube.jView;
    let $textarea: JQuery<HTMLElement> = createTextarea();
    let renderData: FreeObjMap = createRenderData(cube);
    let boxStyle: FreeObjMap = {
        top: '',
        left: renderData.left,
        bottom: renderData.bottom,
        width: renderData.width,
        height: renderData.height
    };

    if (CubeTree.isBeam(parent)) {
        let layerHeight: LogicsicsMeasurement = FrontCubeData.getLogicValue(parent, 'moduleHeight');

        boxStyle.bottom = '';
        boxStyle.top = `-${layerHeight}px`;
    }

    initDom(cube);
    $el.append($textarea).css(boxStyle);
    setValue(cube, renderData);
}

function initDom(cube: CubeNode): void {
    cube.jView.addClass('is-textarea');
    cube.jView.children().each(function(index: number, item: HTMLElement) {
        let $item: JQuery<HTMLElement> = $(item);

        if (!$item.hasClass('ui-resizable-handle')
            && !$item.hasClass('flow-border-left')
            && !$item.hasClass('flow-border-right')
            && !$item.hasClass('flow-border-top')
            && !$item.hasClass('flow-border-bottom')
            && !$item.hasClass('selected-mask')
            && !$item.hasClass('shelvesbuild-e-g-default__in-layer')) {
            $item.remove();
        }
    });
}

function setValue(cube: CubeNode, renderData: FreeObjMap): void {
    let $el: JQuery<HTMLElement> = cube.jView;

    $el.find('.shelvesbuild-e-g-default__textarea-val').css({
        fontSize: renderData.fontSize
    }).text(renderData.title);
}

function createTextarea(): JQuery<HTMLElement> {
    return $(`
        <div class="shelvesbuild-e-g-default__textarea">
            <div class="shelvesbuild-e-g-default__textarea-val"></div>
        </div>'
    `);
}

function createRenderData(cube: CubeNode): FreeObjMap {
    return {
        left: FrontCubeData.getLogicValue(cube.id, 'posX'),
        bottom: FrontCubeData.getLogicValue(cube.id, 'posY'),
        width: FrontCubeData.getLogicValue(cube.id, 'width'),
        height: FrontCubeData.getLogicValue(cube.id, 'height'),
        fontSize: `${FrontCubeData.getValue(cube.id, 'weight')}px`,
        title: FrontCubeData.getValue(cube.id, 'title')
    }
}
